var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isWhitelabel() || _vm.isMetrack())?_c('MonthlyWL'):_c('MonthlyNonWL')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }